import { Component } from "react";
import { connect } from "react-redux";
import  Select from "react-select";
import { SELECT_ACCOUNT } from "../../../../../../actions/addFeedActions";
import { MediaBaseUrl } from "../../../../../../actions/api";
import AccountPicker from "../Elements/AccountPicker";
import CheckBoxField from "../Elements/CheckboxField";
import InfoSection from "../Elements/InfoSection";
import InputField from "../Elements/InputField";

class InstaTabs extends Component {
    state = {
        allAccounts: [{ ConnectedAccounts: { id: 0, value2: 'loading...' } }],
        selectValue: {},
        formatedList: [],
        personalAccountList: [],
        selectPersonal: {},
        allConnectAcc: [],
        allPersonalAcc: []
    }

    componentDidMount() {
        this.getAccounts();
        this.getPersonalAccounts();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.connectedAcc && nextProps.personalAccount) {
            if (this.state.allConnectAcc.length != nextProps.connectedAcc.length) {
                this.getAccounts();
            }
            if (this.state.allPersonalAcc.length != nextProps.personalAccount.length) {
                this.getPersonalAccounts();
            }
        }
    }


    getPersonalAccounts = () => {
        const { personalAccount, onPersonalAccChange } = this.props;
        if (personalAccount && personalAccount.length > 0) {
            const formatedOption = this.formatOption(personalAccount, true);
            onPersonalAccChange(formatedOption[0]);
            this.props.SELECT_ACCOUNT(formatedOption[0]?.value);
            this.setState({ personalAccountList: formatedOption, allPersonalAcc: personalAccount, selectPersonal: formatedOption[0] });
        }
    }
    
    getAccounts = () => {
        const { connectedAcc, onSelectedChildAccountChange } = this.props
        var allAccounts = [];
        if (connectedAcc && connectedAcc.length > 0) {
            connectedAcc && connectedAcc.length && connectedAcc.map(acc => {
                if (acc.ConnectedAccounts.child && acc.ConnectedAccounts.child.length > 0) {
                    allAccounts = [...allAccounts, ...acc.ConnectedAccounts.child];
                }
                else {
                    this.setState({ allAccounts: [] })
                }
            })

            if (allAccounts && allAccounts.length > 0) {
                const formatedOption = this.formatOption(allAccounts, false);
                onSelectedChildAccountChange(formatedOption[0]);
                this.setState({ allAccounts, formatedList: formatedOption, allConnectAcc: connectedAcc, selectValue: formatedOption[0] });
            }
        } else {
            onSelectedChildAccountChange(null)
            this.setState({ allAccounts: [] })
        }
    }

    onAccountChange = (obj) => {
        const { value } = obj;
        const { onPersonalAccChange, onSelectedChildAccountChange, tab , isPersAcc} = this.props;
        if (value && value != "") {
            if (isPersAcc) onPersonalAccChange(obj); 
            else onSelectedChildAccountChange(obj)
            this.props.SELECT_ACCOUNT(value)
        }
        else this.props.SELECT_ACCOUNT(null);
    }

    formatOption = (lists, isPersonal) => {
        const formatedList = lists.map((item) => ({ label: isPersonal ? item.ConnectedAccounts.accountName : item.ConnectedAccounts.value2, value: item.ConnectedAccounts.id }));
        if (formatedList && formatedList.length > 0) {
            return [...formatedList, { label: 'other', value: 0 }];
        }
        return []
    }

    getInfo = (tab) => {
        switch (tab) {
            case 'hashtag':
                return 'Instagram only allows posts from the last 24 hours. If there are no recent posts in the 24-hour duration, then the top 50 posts will be aggregated. Also, all your upcoming posts will be aggregated. Posts collected via hashtags will not include any information of the user.';

            case 'handle':
                return 'Initially 32 posts will be aggregated through handle after which all the upcoming posts will be aggregated.';

            case 'stories':
                return 'Initially stories from the last 24 hours will be shown after which all the upcoming stories will be aggregated.';

            case 'mentions':
                return 'You will only get upcoming posts after creating mentions feed.';

            case 'tagged':
                return 'Initially the latest 32 tagged posts on Instagram will be aggregated after which all the upcoming tagged posts will be aggregated.';
            
            case 'taggedfb':
                return 'Initially the latest 32 tagged posts on Facebook will be aggregated after which all the upcoming tagged posts will be aggregated.';

            case 'videos':
                return 'Initially 25 videos will be aggregated through handle after which all the upcoming videos will be aggregated.';

            case 'personal':
                return 'Initially 32 posts uploaded on personal accounts will be aggregated after which all the upcoming posts will be aggregated.';

            default:
                break;
        }
    }

    render() {
        const { tab,moderation,connetedAccount,onConnectedAccountChange,onCheckHandler,onlyReels,hashtagPost,excludeVideo,onTextChange, personalAccount, handleError, error, onAddAccount, hashtag, handle, filter, connectedAcc, errorMsg, tabName, isPersAcc } = this.props
        const { formatedList, allAccounts, selectValue, personalAccountList, selectPersonal } = this.state
        return (
            <>
                <div className="row">
                    <div className={`${filter == 3 ? "col-md-6" : "col-md-12"}`}>
                        <div className="form-group">
                            {tab == 'hashtag' || tab == "handle" ?
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className={`fas fa-${tab == 'hashtag' ? 'hashtag' : 'at'}`}></i>
                                        </span>
                                    </div>
                                    <InputField name={tab} id={`insta_${tabName}`} className={`autosearch mycheck form-control ${tab == 'hashtag' ? 'hashtag' : 'handle'}`} placeholder={`Enter user ${tab == "handle" ? 'handle' : 'hashtag'}`} value={tab == "hashtag" ? hashtag : handle} onChangeHandler={onTextChange} />
                                    {(tab == "hashtag" && error) || (tab == "handle" && handleError) ? <span className="errorMessage required"> {errorMsg} </span> : null}
                                </div>
                                :
                                <>
                                    {isPersAcc ?
                                        personalAccount && personalAccount.length > 0 ?
                                            <Select className="selectpicker" options={personalAccountList} classNamePrefix="selectpicker" defaultValue={selectPersonal} onChange={(e) => this.onAccountChange(e)} />
                                            :
                                            <div className="py-3 text-center" onClick={onAddAccount}>
                                                <a className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3">
                                                    <span className="symbol symbol-25 me-3">
                                                        <img src={`${MediaBaseUrl}social-icons/instagram.svg`} />
                                                    </span>
                                                    <span className="text-dark-50 font-weight-bolder font-size-base">Connect Instagram</span>
                                                </a>
                                            </div>

                                        :
                                        connectedAcc && connectedAcc.length > 0 && allAccounts && allAccounts.length > 0 ?
                                            <div className="position-relative w-100 mb-3">
                                                <Select className="selectpicker selectpicker-lg" options={formatedList} classNamePrefix="selectpicker" defaultValue={selectValue} onChange={(e) => this.onAccountChange(e)} />
                                            </div>

                                            :
                                            <div className="py-3 text-center" onClick={onAddAccount}>
                                                <a className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3">
                                                    <span className="symbol symbol-25 me-3">
                                                        <img src={`${MediaBaseUrl}social-icons/instagram.svg`} />
                                                    </span>
                                                    <span className="text-dark-50 font-weight-bolder font-size-base">Connect Instagram</span>
                                                </a>
                                            </div>
                                    }
                                </>
                            }
                        </div>
                    </div>

                </div>


                {
                    tab == 'hashtag' ? <div className="hideforBSearch">
                  <CheckBoxField isChecked={hashtagPost} onChangeHandler={onCheckHandler} name={"hashtagPost"} id={`getPost_${tabName}`} text={'Get posts containing hashtag only in caption.'}/>
                    </div> : null
                }
                {
                    tab == "hashtag" || tab == 'handle' ?
                    <div className="hideforBSearch">
                    <CheckBoxField isChecked={excludeVideo} onChangeHandler={onCheckHandler} name={"excludeVideo"} id={`excludeVideo_${tabName}`} text={'Exclude Videos.'}/>
                      </div>  : null
                }
                {
                    !isPersAcc && tab != "taggedfb" ? <div className="hideforBSearch">
                    <CheckBoxField isChecked={onlyReels} onChangeHandler={onCheckHandler} name={"onlyReels"} id={`onlyReels_${tabName}`} text={'Only Reels.'}/>
                      </div>  : null
                }
                <div className="hideforBSearch">
                  <CheckBoxField isChecked={moderation} onChangeHandler={onCheckHandler} name={"moderation"} id={`checkbox_${tabName}`} />
                </div> 
                {connectedAcc && connectedAcc.length && ["hashtag", "handle"].includes(tabName) ? <AccountPicker connectedAcc={connectedAcc} personalAccount={personalAccount} personal={isPersAcc} networkId={'18'} onConnectedAccountChange={onConnectedAccountChange} connetedAccount={connetedAccount} /> : null}
                <InfoSection text={this.getInfo(tab)} />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        connectedAcc: state.addFeedReducer.connectedAcc,
        personalAccount: state.addFeedReducer.personalAccount,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        SELECT_ACCOUNT: (obj) => dispatch(SELECT_ACCOUNT(obj)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InstaTabs)